import { useRef } from "react";
import { useCartState } from "../store/use-cart-state";
import { useCustomerDataState } from "../store/use-customer-data-state";
import { useSearchState } from "../store/use-search-state";
import { useTermsAgreementState } from "../store/use-terms-agreement-state";
import { useUserState } from "../store/use-user-state";

// Wipes per-distribution process state exactly once on mount. Each *Content
// is mounted by a sibling <Route> in the parent <Switch>, so it remounts on
// distribution switch but stays mounted when the user navigates back through
// steps within the same distribution — which is exactly when we want to
// reset (and not). Runs during render before children read state, so guards
// downstream of it see fresh values on the same frame.
export const useResetDistributionState = () => {
  const reset = useRef(false);
  if (!reset.current) {
    reset.current = true;
    useCartState.getState().resetCart();
    useCustomerDataState.getState().clearCustomerData();
    useSearchState.getState().clearSearch();
    useUserState.getState().clearUser();
    useTermsAgreementState.getState().clearTermsAgreement();
  }
};
